import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/freeOpenReason/page/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/freeOpenReason/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/freeOpenReason/save/v2', params, options)
